export const FETCH_ACCOUNTS = 'FETCH_ACCOUNTS';
export const FETCH_ACCOUNTS_COUNT = 'FETCH_ACCOUNTS_COUNT';
export const ADD_ACCOUNTS_SUCCESS = 'ADD_ACCOUNTS_SUCCESS';
export const DELETE_ACCOUNTS_SUCCESS = 'DELETE_ACCOUNTS_SUCCESS';
export const DISABLE_ACCOUNTS_SUCCESS = 'DISABLE_ACCOUNTS_SUCCESS';
export const EDIT_ACCOUNTS_SUCCESS = 'EDIT_ACCOUNTS_SUCCESS';
